module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hrms14x"
    }
  }, [_c('hrms-search-box-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.indexDisp),
      expression: "indexDisp"
    }],
    attrs: {
      "data": _vm.index,
      "nowLang": _vm.dash.nowLang,
      "columns": _vm.columns[_vm.dash.nowLang].index,
      "unLoadBool": true,
      "receivedStore": _vm.receivedHrms14xIndex,
      "columnEvent": _vm.columnEvent,
      "csvExportDisp": true,
      "searchBoxAlias": "hrms14x",
      "callSearchEvent": _vm.callSearchEvent
    },
    model: {
      value: (_vm.searchParams),
      callback: function($$v) {
        _vm.searchParams = $$v
      },
      expression: "searchParams"
    }
  }), _vm._v(" "), _c('input', {
    ref: "popupStatus",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#hrms14x-popup-status",
      "type": "hidden"
    }
  }), _vm._v(" "), _c('input', {
    ref: "popupRouteNo",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#hrms14x-popup-route-no",
      "type": "hidden"
    }
  }), _vm._v(" "), _c('popup-status', {
    attrs: {
      "popupStatusEditDisp": _vm.popupStatusEditDisp,
      "setPopupStatusEditDisp": _vm.setPopupStatusEditDisp,
      "labels": _vm.labels[_vm.dash.nowLang],
      "labelsButton": _vm.dash.button[_vm.dash.nowLang],
      "columns": _vm.columns[_vm.dash.nowLang].popupStatusColumns,
      "columnsStatusEdit": _vm.columns[_vm.dash.nowLang].popupStatusEditColumns,
      "nowLang": _vm.dash.nowLang,
      "data": _vm.popupStatus,
      "dataStatusEdit": _vm.popupStatusEdit,
      "indexSelected": _vm.indexSelected,
      "searchParams": _vm.searchParams,
      "setPopupSelected": _vm.setPopupSelected,
      "popupSelected": _vm.popupSelected,
      "receivedHrms14xStatusEditPopup": _vm.receivedHrms14xStatusEditPopup,
      "postPopupStatusEditSave": _vm.postPopupStatusEditSave,
      "codcomp": _vm.searchParams.codcomp
    }
  }), _vm._v(" "), _c('popup-route-no', {
    attrs: {
      "labels": _vm.labels[_vm.dash.nowLang],
      "columns": _vm.columns[_vm.dash.nowLang].popupRouteNoColumns,
      "nowLang": _vm.dash.nowLang,
      "data": _vm.popupRouteNo,
      "indexSelected": _vm.indexSelected,
      "searchParams": _vm.searchParams
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-69ed6a4c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrms14x/component.vue
// module id = 3832
// module chunks = 1